import React, { useEffect } from 'react';
import '../styles/CaseStudyDetail.css';
import { handleLinkClick } from '../utils/deviceUtils';
import images from '../assets/index';
const CaseStudy4 = () => {

    useEffect(() => {
        document.title = "A Single Customer View for Better Airline Experiences | Datamatics Consulting";
    }, []);
    return (
        <div className="cs-page">

            {/* Hero */}
            <section className="cs-hero">
                <div className="cs-hero-overlay">
                    <span className="cs-sector-badge">Airlines Sector</span>
                    <h1>A Single Customer View for Better Airline Experiences</h1>
                    <p>A national airline unified fragmented passenger data, improving compliance and enhancing the customer journey with accurate, trusted insights.</p>
                </div>
            </section>

            {/* Body */}
            <section className="cs-body container">
                <div className="cs-section">
                    <div className="cs-label">Challenge</div>
                    <div className="cs-content">
                        <p>A leading airline faced multiple fragmented customer data sources, resulting in duplication and no unified view of passengers. The lack of a "single version of the truth" created inefficiencies in customer service, eroded compliance, and limited personalization opportunities.</p>
                    </div>
                </div>
                <div className="cs-divider" />
                <div className="cs-section">
                    <div className="cs-label">Our Approach & Solution</div>
                    <div className="cs-content">
                        <p>We partnered with the airline's operations and customer teams to reframe the challenge: rather than cleaning up data piecemeal, the goal was to create a <strong>unified customer profile</strong> that could drive both compliance and customer experience improvements.</p>
                        <p>Datamatics implemented <strong>Master Data Management (MDM)</strong> and comprehensive <strong>Data Governance frameworks</strong>. This ensured that every passenger record was deduplicated, accurate, and consistently managed across systems — giving the airline a trusted foundation for operations and customer engagement.</p>
                    </div>
                </div>
            </section>

            {/* Results */}
            <section className="cs-results">
                <h2>Results</h2>
                <div className="cs-results-grid">
                    <div className="cs-stat">
                        <span className="cs-stat-number">30%</span>
                        <p>Reduction in duplicate records, cutting waste and errors.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">20%</span>
                        <p>Faster query resolution, improving operational efficiency.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">35%</span>
                        <p>Stronger compliance with aviation data standards.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">100%</span>
                        <p>Enhanced customer experience through consistent and accurate passenger insights.</p>
                    </div>
                </div>
            </section>

            {/* Other Case Studies */}
            <section className="cs-related container">
                <div className="cs-related-header">
                    <div className="purple-line-cs"></div>
                    <span className="cs-related-label">Case Studies</span>
                </div>
                <div className="cs-cards-grid">
                    {[
                        { title: "Building a Trusted Data Foundation for Financial Services", image: images.newcase1, to: "/case-studies/financial-services" },
                        { title: "Modernizing Compliance & Reporting with Data at Scale", image: images.newcase2, to: "/case-studies/banking" },
                        { title: "Unified Data for Smarter Insurance Decisions", image: images.newcase3, to: "/case-studies/insurance" },
                    ].map((s, i) => (
                        <div key={i} className="cs-card" onClick={() => handleLinkClick(s.to)} style={{ cursor: 'pointer' }}>
                            <div className="cs-card-img-wrap">
                                <img src={s.image} alt={s.title} />
                            </div>
                            <h3>{s.title}</h3>
                            <a href={s.to} className="cs-read-more" onClick={(e) => { e.preventDefault(); handleLinkClick(s.to); }}>Read More →</a>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default CaseStudy4;